// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo--BEkfjoQhcSBx8Gb02Uz4"};